import { render, staticRenderFns } from "./MspRichiestaAbbinamento.vue?vue&type=template&id=c6180cc8"
import script from "./MspRichiestaAbbinamento.vue?vue&type=script&lang=js"
export * from "./MspRichiestaAbbinamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports